import * as React from 'react';
import PropTypes from 'prop-types';
import { Sortable } from '@progress/kendo-react-sortable';

/**
 * Sortable component
 * @module
 * @param {array} data - Data
 * @param {string} idField - Id field name
 * @param {string} disabledField - Disabled field name
 * @param {React.Component} SortableItemUI - Sortable item ui 
 * @param {func} onDragOver - On drag over
 * @param {func} onNavigate - On navigate
 */
const SortableComponent = (props) => (
  <Sortable
    idField={props.idField}
    disabledField={props.disabledField}
    data={props.data}
    itemUI={props.SortableItemUI}
    onDragOver={props.onDragOver}
    onNavigate={props.onNavigate}
  />
)

SortableComponent.propTypes = {
  data: PropTypes.array.isRequired,
  idField: PropTypes.string,
  disabledField: PropTypes.string,
  SortableItemUI: PropTypes.func.isRequired,
  onDragOver: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired
}

export default SortableComponent;